import { useCallback } from 'react';
import { itemsLabel, translate, useAppStore } from '@restorant/core';
import type { Lang, StringKey, Vars } from '@restorant/core';

export function useLang(): Lang {
  return useAppStore((s) => s.lang);
}

/** t('place_order') / t('items_n', { n: 3 }) */
export function useT() {
  const lang = useLang();
  return useCallback(
    (key: StringKey, vars?: Vars) => translate(lang, key, vars),
    [lang],
  );
}

/** t-style helper that pluralises: 1 -> "1 item", 5 -> "5 items". */
export function useItemsLabel() {
  const lang = useLang();
  return useCallback((n: number) => itemsLabel(lang, n), [lang]);
}


// Category names come from the menu tables now — re-exported here so screens
// keep a single import site.
export { useCategoryLabel as useCatLabel } from './menu';

// Table names come from the floor-plan table now — re-exported here so screens
// keep a single import site, exactly as category names are.
export { useTableName as useTableLabel } from './menu';
